export default "__VITE_PUBLIC_ASSET__76b7801c__"